import React from 'react'
import '../assets/css/PlayerSubScreen.css'
import headerLogo from '../assets/images/PlayerScreen/HeaderLogoo.svg'


const Header = () => {
    return (
        <>

            <div className="row player-screen-header position-relative " style={{zIndex:"15"}}>

                <div className="col-6 player-screen-header-text d-flex justify-content-end">
                    <p className='player-screen-header-text-right  mt-3 '>THE MORE YOU WIN</p>
                </div>

                <div className="col-6 player-screen-header-text">
                    <p className='player-screen-header-text-left  mt-3 '>THE LUCKIER YOU GET</p>
                </div>

                <div className=' text-light position-absolute player-screen-header-logo'>
                    <img src={headerLogo} alt="" />
                </div>

            </div>

        </>
    )
}

export default Header